import { useQuery } from "react-query";
import { fetchStoresRegionNameAndId } from "./services/StoresService";
import { CACHE_TTL_MS } from "./ttl.cache";

export const useStoresData= (options = {}) => {
  const { shouldFetchStores = false } = options;

  const query = useQuery({
    queryKey: ["stores"],

    queryFn: async () => {
      const data = await fetchStoresRegionNameAndId();
      return data;
    },

    staleTime: CACHE_TTL_MS.TTL_12_HOURS,
    cacheTime: CACHE_TTL_MS.TTL_24_HOURS,
    enabled: shouldFetchStores,
    refetchOnMount: false,

    ...options,
  });

  return {
    storeNameRegionAndId: query
  };
};